import { awaitDataServiceFetcher } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/DataServiceFetchers';
import { PartyIdentification } from '../../../../../card/src/types';
import { PartyRole } from '../../../../../transaction/src/contexts/Parameters/types';
import { CardHeaders, DashboardData } from '../entities';
import { EntitlementsData } from '../entities/EntitlementsDataResponseDTO';
import { IUserInfoRepository } from '../entities/IUserInfoRepository';
import { PartyRelationship } from '../entities/PostLoginCardResponseDTO';
import {
  dashboardDataResponseDTOtoDashboardDataAdapter,
  postLoginCardResponseDTOtoPostLoginCardAdapter,
  entitlementsDataResponseDTOtoEntitlementsDataAdapter,
} from './';

class DashboardRepositoryImpl implements IUserInfoRepository {
  constructor() {
    this.GetDashboardData = this.GetDashboardData.bind(this);
    this.GetEntitlementsData = this.GetEntitlementsData.bind(this);
  }

  GetDashboardData(): Promise<DashboardData> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: '/secure-web/api/private/accounts/dashboard',
        dataAdapter: dashboardDataResponseDTOtoDashboardDataAdapter,
      },
    });
  }

  GetEntitlementsData(companyId: string): Promise<EntitlementsData> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'GET',
        url: '/secure-web/api/private/users/appTransactions',
        dataAdapter: entitlementsDataResponseDTOtoEntitlementsDataAdapter,
        params: { customerId: companyId },
      },
    });
  }

  PostLoginCard(customerId: string): Promise<{
    cardHeaders: CardHeaders;
    selectedPartyIdentification?: PartyIdentification;
    partyRelationships?: PartyRelationship[];
    partyRoles?: PartyRole[];
  }> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'POST',
        url: '/secure-web/dx4b/login/post-login',
        dataAdapter: postLoginCardResponseDTOtoPostLoginCardAdapter,
        headers: {
          Platform: 'web'
        },
        data: {
          headers: [],
          body: {
            partyIdentifications: [
              {
                type: 'CoreBankingIdentifier',
                identifier: {
                  value: customerId,
                  issuingAuthority: 'Profits',
                },
              },
            ],
          },
        },
      },
    });
  }
}

export { DashboardRepositoryImpl };
